/* custom-full-banner */
function adjustHeroHeights() {
  if (window.innerWidth > 768) {
    // Reset min-heights when going back to desktop
    document.querySelectorAll('#full-bg-image .full-blend-hero-section-container-mobile-image')
      .forEach(mobileImage => mobileImage.style.minHeight = '');
    return;
  }

  document.querySelectorAll('#full-bg-image').forEach(section => {
    const box = section.querySelector('.full-blend-hero-section-container-box-content-container');
    const mobileImage = section.querySelector('.full-blend-hero-section-container-mobile-image');

    if (box && mobileImage) {      
      box.style.height = 'auto';
      const boxHeight = box.offsetHeight;      
      box.style.height = '';      
      mobileImage.style.minHeight = boxHeight + 100 + 'px';
    }
  });
}
document.addEventListener('DOMContentLoaded', adjustHeroHeights);
window.addEventListener('load', adjustHeroHeights);
window.addEventListener('resize', adjustHeroHeights);

/* custom-full-banner */





// product modal

$(".Click-here").on('click', function() {
  $(".custom-model-main").addClass('model-open');
}); 
$(".close-btn, .bg-overlay").click(function(){
  $(".custom-model-main").removeClass('model-open');
});

// announcement

// mobile only slider grid layout
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 768) {
    var swiper = new Swiper('.custom-swipe-mobile', {
      slidesPerView: 1,    // You can adjust how many slides you want to show
      spaceBetween: 10,
       navigation: {
        nextEl: ".swiper-ann-btn-next",
        prevEl: ".swiper-ann-btn-prev",
      },
    });
  }
});

// Check if there are more than 1 slide
document.addEventListener('DOMContentLoaded', function() {
  var slideCount = document.querySelectorAll('.announcement_sliers .swiper-slide').length;

  if (slideCount > 1) {
    var swiper = new Swiper(".announcement_sliers", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-ann-btn-next",
        prevEl: ".swiper-ann-btn-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        480: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
      },
    });
  } else {
    // Hide arrows if there's only one slide
    document.querySelector('.swiper-ann-btn-prev').style.display = 'none';
    document.querySelector('.swiper-ann-btn-next').style.display = 'none';
  }
});

 
// end announcement

// index hero-layout2-slide inner
  var swiperNew = new Swiper(".hero-slide-inner", {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true, 
    },
  });
// footer mobile menu start 

$(document).ready(function(){
function handleMobileMenu() {
  if ($(window).width() <= 768) {
    
    $(".ab-footer-linklist").hide();
    $(".ab-icon-arrow").off('click').on('click', function(){
      
      var menu = $(this).closest('.footer-menu-block').find('.ab-footer-linklist');

      
      if(menu.is(':visible')){
        menu.slideUp();
        $(this).removeClass('rotate-arrow'); 
      } 
      
      else {
        $(".ab-footer-linklist").slideUp(); 
        $(".ab-icon-arrow").removeClass('rotate-arrow'); 
        menu.slideDown(); 
        $(this).addClass('rotate-arrow'); 
      }

      $("body").toggleClass("active-menu", menu.is(':visible'));
    });
  } else {
    
    $(".ab-footer-linklist").show(); 
    $(".ab-icon-arrow").removeClass('rotate-arrow'); 
  }
}
handleMobileMenu();

$(window).resize(function(){
  handleMobileMenu();
});
});

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('galleryReady:covetPics', function(e) {
    /*// prepare CSS styles to inject*/
    const stylesPopup = document.createElement('style')
    stylesPopup.innerHTML = `
      covet-pics-gallery-slider section.gallery .swiper-pagination.dots { display: none; }
    `;
    /*// get Covet gallery elements where you want to inject CSS (for eg. covet-pics-widget, covet-pics-popup, covet-pics-upload)*/
    const popup = document.querySelector("covet-pics-widget");

    /*// now inject CSS code into shadow DOM*/
    popup.shadowRoot.appendChild(stylesPopup);
   
    popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.centeredSlides = true;
    stylesPopup.innerHTML = `
      covet-pics-gallery-slider section.gallery .swiper-pagination.dots { display: none; }
    `;
    /*if (window.innerWidth < 750) {
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.slidesPerView = 1.7342;      
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.initialSlide = 1;
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.spaceBetween = 10;
    } else { }*/
      var breakPointObj = popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.breakpoints;
      breakPointObj[1551] = {
        slidesPerView: 6.32,
        spaceBetween: 15
      };
      breakPointObj[1200] = {
        slidesPerView: 4.77,
        spaceBetween: 15
      };
      breakPointObj[800] = {     
        slidesPerView: 2.77,   
        spaceBetween: 15
      };
      breakPointObj[750] = breakPointObj[800];
      breakPointObj[0] = {        
        spaceBetween: 10,
        initialSlide: 1,
        slidesPerView: 1.7342
      };
      popup.shadowRoot.querySelector('.gallery.swiper').swiper.params.breakpoints = breakPointObj;      
   
    popup.shadowRoot.querySelector('.gallery.swiper').swiper.update();
    if (window.innerWidth < 750) { popup.shadowRoot.querySelector('.gallery.swiper').swiper.slideTo(1); }else{
      if (window.innerWidth > 800) {
        popup.shadowRoot.querySelector('.gallery.swiper').swiper.slideTo(3);
      }else{
        popup.shadowRoot.querySelector('.gallery.swiper').swiper.slideTo(1);
      }
    }
  });
});

// footer mobile menu end 

//EN FR store class add. 
document.addEventListener("DOMContentLoaded", function () {
  const htmlTag = document.documentElement;
  if (htmlTag.lang === "en") {
    document.body.classList.add("store-en");
  } else if (htmlTag.lang === "fr") {
    document.body.classList.add("store-fr");
  }
});